import {
  InfoPanelTitle,
  InfoPanelDescription,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function BusinessActivityDescriptionInfoContent() {
  return (
    <>
      <InfoPanelTitle>How to explain business activity?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Enter a short description of what your business does. This helps the
          IRS understand the type of work you perform in addition to the
          activity code you selected.
        </p>
        <p>
          Describe your main revenue-producing activity in simple, everyday
          language. Keep it brief, usually 3–8 words is enough.
        </p>
        <p>
          <strong>Examples:</strong>
        </p>
        <ul>
          <li>Residential cleaning services</li>
          <li>Online clothing sales</li>
          <li>Software development consulting</li>
          <li>Graphic design services</li>
          <li>Landscaping and lawn care</li>
          <li>Short-term rental management</li>
        </ul>
      </InfoPanelDescription>
    </>
  )
}
